module.exports = __webpack_public_path__ + "static/media/08diaoduzhongxinpiaowu2.05b34b26.png";